export const translations = {
  pt: {
    nav: {
      home: 'Início',
      devices: 'Dispositivos',
      contact: 'Contato',
      enterPlatform: 'Entrar na Plataforma',
      requestQuote: 'Solicitar Orçamento'
    },
    hero: {
      title: 'Rastreamento GPS',
      titleHighlight: 'Profissional',
      subtitle: 'Soluções completas de rastreamento veicular com tecnologia de ponta. Proteja seu patrimônio com dispositivos de alta qualidade e suporte especializado.',
      viewDevices: 'Ver Dispositivos',
      requestQuote: 'Solicitar Orçamento'
    },
    features: {
      security: 'Segurança Total',
      securityDesc: 'Proteção 24/7 com alertas em tempo real',
      realtime: 'Rastreamento Real-Time',
      realtimeDesc: 'Localização precisa a qualquer momento',
      coverage: 'Cobertura Global',
      coverageDesc: 'Monitoramento em qualquer lugar do mundo'
    },
    contact: {
      title: 'Solicite um Orçamento',
      description: 'Preencha o formulário e nossa equipe entrará em contato para fornecer a melhor solução de rastreamento para suas necessidades.',
      specialized: 'Atendimento Especializado',
      specializedDesc: 'Consultoria personalizada para seu negócio',
      installation: 'Instalação Profissional',
      installationDesc: 'Técnicos certificados e experientes',
      support: 'Suporte Contínuo',
      supportDesc: 'Assistência técnica sempre que precisar'
    }
  },
  en: {
    nav: {
      home: 'Home',
      devices: 'Devices',
      contact: 'Contact',
      enterPlatform: 'Enter Platform',
      requestQuote: 'Request Quote'
    },
    hero: {
      title: 'Professional GPS',
      titleHighlight: 'Tracking',
      subtitle: 'Complete vehicle tracking solutions with cutting-edge technology. Protect your assets with high-quality devices and specialized support.',
      viewDevices: 'View Devices',
      requestQuote: 'Request Quote'
    },
    features: {
      security: 'Total Security',
      securityDesc: '24/7 protection with real-time alerts',
      realtime: 'Real-Time Tracking',
      realtimeDesc: 'Precise location at any time',
      coverage: 'Global Coverage',
      coverageDesc: 'Monitoring anywhere in the world'
    },
    contact: {
      title: 'Request a Quote',
      description: 'Fill out the form and our team will contact you to provide the best tracking solution for your needs.',
      specialized: 'Specialized Service',
      specializedDesc: 'Personalized consultation for your business',
      installation: 'Professional Installation',
      installationDesc: 'Certified and experienced technicians',
      support: 'Continuous Support',
      supportDesc: 'Technical assistance whenever you need'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      devices: 'Dispositivos',
      contact: 'Contacto',
      enterPlatform: 'Entrar a la Plataforma',
      requestQuote: 'Solicitar Cotización'
    },
    hero: {
      title: 'Rastreo GPS',
      titleHighlight: 'Profesional',
      subtitle: 'Soluciones completas de rastreo vehicular con tecnología de vanguardia. Protege tu patrimonio con dispositivos de alta calidad y soporte especializado.',
      viewDevices: 'Ver Dispositivos',
      requestQuote: 'Solicitar Cotización'
    },
    features: {
      security: 'Seguridad Total',
      securityDesc: 'Protección 24/7 con alertas en tiempo real',
      realtime: 'Rastreo en Tiempo Real',
      realtimeDesc: 'Ubicación precisa en cualquier momento',
      coverage: 'Cobertura Global',
      coverageDesc: 'Monitoreo en cualquier lugar del mundo'
    },
    contact: {
      title: 'Solicite una Cotización',
      description: 'Complete el formulario y nuestro equipo se pondrá en contacto para proporcionar la mejor solución de rastreo para sus necesidades.',
      specialized: 'Atención Especializada',
      specializedDesc: 'Consultoría personalizada para su negocio',
      installation: 'Instalación Profesional',
      installationDesc: 'Técnicos certificados y experimentados',
      support: 'Soporte Continuo',
      supportDesc: 'Asistencia técnica siempre que la necesite'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      devices: 'Appareils',
      contact: 'Contact',
      enterPlatform: 'Entrer sur la Plateforme',
      requestQuote: 'Demander un Devis'
    },
    hero: {
      title: 'Suivi GPS',
      titleHighlight: 'Professionnel',
      subtitle: 'Solutions complètes de suivi de véhicules avec une technologie de pointe. Protégez votre patrimoine avec des appareils de haute qualité et un support spécialisé.',
      viewDevices: 'Voir les Appareils',
      requestQuote: 'Demander un Devis'
    },
    features: {
      security: 'Sécurité Totale',
      securityDesc: 'Protection 24/7 avec alertes en temps réel',
      realtime: 'Suivi en Temps Réel',
      realtimeDesc: 'Localisation précise à tout moment',
      coverage: 'Couverture Mondiale',
      coverageDesc: 'Surveillance partout dans le monde'
    },
    contact: {
      title: 'Demandez un Devis',
      description: 'Remplissez le formulaire et notre équipe vous contactera pour fournir la meilleure solution de suivi pour vos besoins.',
      specialized: 'Service Spécialisé',
      specializedDesc: 'Consultation personnalisée pour votre entreprise',
      installation: 'Installation Professionnelle',
      installationDesc: 'Techniciens certifiés et expérimentés',
      support: 'Support Continu',
      supportDesc: 'Assistance technique quand vous en avez besoin'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      devices: 'Geräte',
      contact: 'Kontakt',
      enterPlatform: 'Plattform Betreten',
      requestQuote: 'Angebot Anfordern'
    },
    hero: {
      title: 'Professionelles GPS',
      titleHighlight: 'Tracking',
      subtitle: 'Vollständige Fahrzeugverfolgungslösungen mit modernster Technologie. Schützen Sie Ihr Vermögen mit hochwertigen Geräten und spezialisierter Unterstützung.',
      viewDevices: 'Geräte Anzeigen',
      requestQuote: 'Angebot Anfordern'
    },
    features: {
      security: 'Totale Sicherheit',
      securityDesc: '24/7 Schutz mit Echtzeit-Benachrichtigungen',
      realtime: 'Echtzeit-Tracking',
      realtimeDesc: 'Präzise Standortbestimmung jederzeit',
      coverage: 'Globale Abdeckung',
      coverageDesc: 'Überwachung überall auf der Welt'
    },
    contact: {
      title: 'Angebot Anfordern',
      description: 'Füllen Sie das Formular aus und unser Team wird Sie kontaktieren, um die beste Tracking-Lösung für Ihre Bedürfnisse bereitzustellen.',
      specialized: 'Spezialisierter Service',
      specializedDesc: 'Personalisierte Beratung für Ihr Unternehmen',
      installation: 'Professionelle Installation',
      installationDesc: 'Zertifizierte und erfahrene Techniker',
      support: 'Kontinuierlicher Support',
      supportDesc: 'Technische Unterstützung wann immer Sie sie brauchen'
    }
  },
  it: {
    nav: {
      home: 'Home',
      devices: 'Dispositivi',
      contact: 'Contatto',
      enterPlatform: 'Accedi alla Piattaforma',
      requestQuote: 'Richiedi Preventivo'
    },
    hero: {
      title: 'Tracciamento GPS',
      titleHighlight: 'Professionale',
      subtitle: 'Soluzioni complete di tracciamento veicolare con tecnologia all\'avanguardia. Proteggi il tuo patrimonio con dispositivi di alta qualità e supporto specializzato.',
      viewDevices: 'Visualizza Dispositivi',
      requestQuote: 'Richiedi Preventivo'
    },
    features: {
      security: 'Sicurezza Totale',
      securityDesc: 'Protezione 24/7 con alert in tempo reale',
      realtime: 'Tracciamento in Tempo Reale',
      realtimeDesc: 'Localizzazione precisa in qualsiasi momento',
      coverage: 'Copertura Globale',
      coverageDesc: 'Monitoraggio ovunque nel mondo'
    },
    contact: {
      title: 'Richiedi un Preventivo',
      description: 'Compila il modulo e il nostro team ti contatterà per fornire la migliore soluzione di tracciamento per le tue esigenze.',
      specialized: 'Servizio Specializzato',
      specializedDesc: 'Consulenza personalizzata per la tua azienda',
      installation: 'Installazione Professionale',
      installationDesc: 'Tecnici certificati ed esperti',
      support: 'Supporto Continuo',
      supportDesc: 'Assistenza tecnica ogni volta che ne hai bisogno'
    }
  }
};

